const quickStartRouter = [
  {
    path: 'case-solution',
    name: 'docs.caseSolution',
    component: () => import('@/apps/open/views/fileCenter/components/FileContent.vue'),
    meta: { title: '案例解决方案', mdfilepath: '/case/CaseSolution.md' }
  },
  {
    path: 'basic-ability/account-oauth',
    component: () => import('@/apps/open/views/fileCenter/components/FileRouter.vue'),
    redirect: 'basic-ability/account-oauth/access-know',
    meta: { title: '使用WPS账号授权登录', path: '/docs/cloud/basic-ability/account-oauth/access-know' },
    children: [
      {
        path: 'access-know',
        name: '',
        component: () => import('@/apps/open/views/fileCenter/components/FileContent.vue'),
        meta: { title: '接入须知', mdfilepath: '/basicability/accountoauth/AccessKnow.md' }
      }
    ]
  },
  {
    path: 'cloudfile-ability/manage',
    component: () => import('@/apps/open/views/fileCenter/components/FileRouter.vue'),
    redirect: 'cloudfile-ability/manage/access-know',
    meta: { title: '管理云文档文件', path: '/docs/cloud/cloudfile-ability/manage/access-know' },
    children: [
      {
        path: 'access-know',
        name: '',
        component: () => import('@/apps/open/views/fileCenter/components/FileContent.vue'),
        meta: { title: '接入须知', mdfilepath: '/cloudfileability/managecloudfile/AccessKnow.md' }
      }
    ]
  },
  {
    path: 'basic-ability/wps-pay',
    component: () => import('@/apps/open/views/fileCenter/components/FileRouter.vue'),
    redirect: 'basic-ability/wps-pay/access-know',
    meta: { title: 'WPS支付', path: '/docs/cloud/basic-ability/wps-pay/access-know' },
    children: [
      {
        path: 'access-know',
        name: '',
        component: () => import('@/apps/open/views/fileCenter/components/FileContent.vue'),
        meta: { title: '接入须知', mdfilepath: '/basicability/wpspay/AccessKnow.md' }
      }
    ]
  },
  {
    path: 'error-code',
    name: '',
    component: () => import('@/apps/open/views/fileCenter/components/FileContent.vue'),
    meta: { title: '常见错误码', mdfilepath: '/returncode/YunCode.md' }
  },
  {
    path: 'FAQ',
    name: '',
    component: () => import('@/apps/open/views/fileCenter/components/FileContent.vue'),
    meta: { title: '常见问题', mdfilepath: '/questions/YunQuestions.md' }
  }
]

export default quickStartRouter
